module.exports = __webpack_public_path__ + "img/ico-circle-stores.bdb498ae.svg";